export type AnalyticsEvent =
  | "resolve_started"
  | "resolve_result"
  | "copy_text"
  | "save_started"
  | "save_completed"
  | "save_failed"
  | "feedback_submitted"
  | "open_original"
  | "ai_referral_landing"
  | "guide_cta_click"
  | "subtitle_manifest_started"
  | "subtitle_manifest_result"
  | "media_download";

export type AIReferralSource = "chatgpt" | "perplexity" | "claude" | "copilot" | "gemini";

export interface TrackOptions {
  includePageLocale?: boolean;
}

export function track(event: AnalyticsEvent, params: Record<string, string | number | boolean> = {}, options: TrackOptions = {}): void {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  const pageLocale = typeof document !== "undefined" ? document.documentElement.lang : "";
  const includePageLocale = options.includePageLocale !== false;
  window.gtag("event", event, includePageLocale && pageLocale ? { page_locale: pageLocale, ...params } : params);
}

export function trackPageView(path: string): void {
  if (typeof window === "undefined" || typeof document === "undefined" || typeof window.gtag !== "function") return;
  const pageURL = new URL(path, window.location.origin);
  window.gtag("event", "page_view", {
    page_path: pageURL.pathname,
    page_location: `${pageURL.origin}${pageURL.pathname}`,
    page_title: document.title,
    page_locale: document.documentElement.lang
  });
}

export function classifyAIReferrer(value: string): AIReferralSource | null {
  if (!value) return null;
  let hostname: string;
  try {
    hostname = new URL(value).hostname.toLowerCase().replace(/^www\./, "");
  } catch {
    return null;
  }
  if (hostname === "chatgpt.com" || hostname.endsWith(".chatgpt.com")) return "chatgpt";
  if (hostname === "perplexity.ai" || hostname.endsWith(".perplexity.ai")) return "perplexity";
  if (hostname === "claude.ai" || hostname.endsWith(".claude.ai")) return "claude";
  if (hostname === "copilot.microsoft.com" || hostname.endsWith(".copilot.microsoft.com")) return "copilot";
  if (hostname === "gemini.google.com" || hostname.endsWith(".gemini.google.com")) return "gemini";
  return null;
}

export function trackAIReferralLanding(pageKind: string): void {
  if (typeof document === "undefined") return;
  const source = classifyAIReferrer(document.referrer);
  if (!source) return;
  track("ai_referral_landing", { ai_source: source, landing_page: pageKind });
}
